import React from "react";
import { IconButton, useTheme } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu"; // Ensure this is the correct import
import { DefaultLayoutZIndex } from "../../../_utils/constraints"; // Check this path
import { motion } from "framer-motion";
import { useLayout } from "../../_context/DefaultProvider";

const MotionIconButton = motion(IconButton);

const MenuButton = ({ istop = true, handleClick = () => {} }) => {
  const { visibility } = useLayout();
  const { palette } = useTheme();

  // Define animation variants
  const variants = {
    hidden: { scale: 0, opacity: 0 },
    visible: {
      scale: 0.95,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 20,
      },
    },
    hover: {
      scale: 1,
      transition: { duration: 0.2 },
    },
    tap: {
      scale: 0.95,
    },
  };

  return (
    <MotionIconButton
      onClick={handleClick}
      variants={variants}
      initial="hidden"
      animate="visible"
      whileHover="hover"
      whileTap="tap"
      style={{
        backgroundColor: palette.primary.main,
        color: palette.common.white,
        ":hover": {
          color: palette.primary.main,
          backgroundColor: palette.common.white,
        },
        boxShadow: istop && !visibility.showAppBar ? 2 : 0,
        cursor: "pointer",
        p: 0,
        position: istop ? "fixed" : "relative",
        top: istop ? "10px" : "auto",
        right: istop ? "10px" : "auto",
        height: "50px",
        width: istop ? "50px" : "auto",
        zIndex: istop ? DefaultLayoutZIndex + 15 : "auto",
        marginRight: istop ? 0 : "3px",
        transition: "all 0.3s ease", // Smooth transition for all properties
      }}
    >
      <MenuIcon
        style={{ padding: 0, margin: 0, width: "40px", height: "40px" }}
      />
    </MotionIconButton>
  );
};

export default MenuButton;
